'use client';
function isScrollingWithinScrollbarBounds(scrollPos, maxScrollPos) {
  return scrollPos > 0 && scrollPos < maxScrollPos;
}

export { isScrollingWithinScrollbarBounds };
//# sourceMappingURL=is-scrolling-within-scrollbar-bounds.mjs.map
